<template>
  <div v-if="isOpen" class="mobile-navigation-menu">
    <div class="mobile-header">
      <div class="logo-section">
        <router-link to="/home">
          <img src="/platform_logo.svg" :alt="SITE_NAME" />
        </router-link>
      </div>
      <CloseOutlined
        @click="$emit('update:is-open', false)"
        class="close-icon"
      />
    </div>

    <div class="mobile-nav">
      <!-- 最新消息 -->
      <router-link
        to="/activities"
        class="mobile-item"
        @click="handleMenuClick"
      >
        {{ $t("navbar.latestNews") }}
      </router-link>

      <!-- 簡介與沿革 -->
      <div @click="toggleIntroMenu" class="mobile-item">
        {{ $t("navbar.platformIntro") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showIntroMenu ? 180 : 0"
        />
      </div>
      <div v-show="showIntroMenu" class="sub-menu">
        <router-link
          to="/minister-intro"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.ministerIntro") }}
        </router-link>
        <router-link
          to="/vice-minister-intro"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.viceMinisterIntro") }}
        </router-link>
        <router-link
          to="/director-intro"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.directorIntro") }}
        </router-link>
        <!-- <router-link
          to="/expert-directory"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.expertDirectory") }}
        </router-link> -->
      </div>

      <!-- SNOMED CT介紹 -->
      <div @click="toggleSnomedMenu" class="mobile-item">
        {{ $t("navbar.snomedCtIntro") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showSnomedMenu ? 180 : 0"
        />
      </div>
      <div v-show="showSnomedMenu" class="sub-menu">
        <router-link
          to="/snomed-ct"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.whatIsSnomedCt") }}
        </router-link>
        <router-link
          to="/snomed-ct-education"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.snomedCtEducation") }}
        </router-link>
      </div>

      <!-- 培訓認證 -->
      <div @click="toggleTrainingMenu" class="mobile-item">
        {{ $t("navbar.training") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showTrainingMenu ? 180 : 0"
        />
      </div>
      <div v-show="showTrainingMenu" class="sub-menu">
        <router-link
          to="/workshop-courses"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.workshopCourses") }}
        </router-link>
        <router-link
          to="/workshop-materials"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.workshopMaterials") }}
        </router-link>
        <router-link
          to="/certification-apply"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.certificationApply") }}
        </router-link>
      </div>

      <!-- 臺灣標準 -->
      <div @click="toggleStandardsMenu" class="mobile-item">
        {{ $t("navbar.taiwanStandards") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showStandardsMenu ? 180 : 0"
        />
      </div>
      <div v-show="showStandardsMenu" class="sub-menu">
        <router-link
          to="/standard-announcements"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.standardAnnouncements") }}
        </router-link>
      </div>

      <!-- 術語搜尋 (暫時隱藏) -->
      <!-- <div @click="toggleTerminologyMenu" class="mobile-item">
        {{ $t("navbar.terminologySearch") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showTerminologyMenu ? 180 : 0"
        />
      </div>
      <div v-show="showTerminologyMenu" class="sub-menu">
        <a
          href="#"
          target="_blank"
          class="mobile-sub-item disabled"
          @click="handleMenuClick"
        >
          {{ $t("navbar.terminologyTaiwan") }}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z"
              fill="black"
            />
          </svg>
        </a>
        <a
          href="#"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.terminologyInternational") }}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z"
              fill="black"
            />
          </svg>
        </a>
      </div> -->

      <!-- 支援中心 -->
      <router-link
        to="/customer-service"
        class="mobile-item"
        @click="handleMenuClick"
      >
        {{ $t("navbar.supportCenter") }}
      </router-link>

      <!-- 計劃網站 -->
      <div @click="toggleProjectMenu" class="mobile-item">
        {{ $t("navbar.projectWebsites") }}
        <DownOutlined
          style="margin-left: 6px"
          :rotate="showProjectMenu ? 180 : 0"
        />
      </div>
      <div v-show="showProjectMenu" class="sub-menu">
        <a
          :href="PROJECT_WEBSITE_LINKS?.medStandard || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectMedStandard") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.thds || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectThds") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.thrs || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectThrs") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.thas || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectThas") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.snomedCt || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectSnomedCt") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.loinc || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectLoinc") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.rxnorm || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectRxNorm") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.smartHealth || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectSmartHealth") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.aiCenter || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectAiCenter") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.aiCenter1 || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectAiCenter1") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
        <a
          :href="PROJECT_WEBSITE_LINKS?.aiCenter2 || '#'"
          target="_blank"
          class="mobile-sub-item"
          @click="handleMenuClick"
        >
          {{ $t("navbar.projectAiCenter2") }}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { message } from "ant-design-vue";
import { CloseOutlined, DownOutlined } from "@ant-design/icons-vue";
import { authAPI, PROJECT_WEBSITE_LINKS } from "../services/api";
import { SITE_NAME } from "../constants/site";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:is-open", "menu-click"]);

const { t } = useI18n();
const showIntroMenu = ref(false);
const showSnomedMenu = ref(false);
const showTrainingMenu = ref(false);
const showStandardsMenu = ref(false);
const showTerminologyMenu = ref(false);
const showProjectMenu = ref(false);

function toggleIntroMenu() {
  showIntroMenu.value = !showIntroMenu.value;
}

function toggleSnomedMenu() {
  showSnomedMenu.value = !showSnomedMenu.value;
}

function toggleTrainingMenu() {
  showTrainingMenu.value = !showTrainingMenu.value;
}

function toggleStandardsMenu() {
  showStandardsMenu.value = !showStandardsMenu.value;
}

function toggleTerminologyMenu() {
  showTerminologyMenu.value = !showTerminologyMenu.value;
}

function toggleProjectMenu() {
  showProjectMenu.value = !showProjectMenu.value;
}

function handleMenuClick() {
  emit("update:is-open", false);
  emit("menu-click");
}

async function handleLogout() {
  try {
    await authAPI.logout();

    localStorage.removeItem("ms_platform_token");
    localStorage.removeItem("user_data");

    emit("update:is-open", false);
    message.success("您已成功登出");
    window.location.href = "/";
  } catch (error) {
    console.error("登出處理發生錯誤:", error);

    localStorage.removeItem("ms_platform_token");
    localStorage.removeItem("user_data");

    emit("update:is-open", false);
    message.warning("登出處理發生問題，但您已在本機登出");
    window.location.href = "/";
  }
}
</script>

<style lang="scss" scoped>
.mobile-navigation-menu {
  position: fixed;
  top: 58px;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 1000;
  overflow-y: auto;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.logo-section img {
  height: auto;
  width: auto;
  outline: none;
  max-height: 45px;
}

.close-icon {
  font-size: 24px;
  color: #666;
  cursor: pointer;
}

.mobile-nav {
  padding: 20px;
}

.mobile-item {
  display: block;
  padding: 16px 0;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &.disabled {
    color: #B5B5B5 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none;
    svg path {
      fill: #B5B5B5 !important;
    }
  }
}

.mobile-item:hover {
  color: #1890ff;
}

.sub-menu {
  background: #f8f9fa;
  padding: 0 20px;
}

.mobile-sub-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  border-bottom: 1px solid #e8e8e8;

  &.disabled {
    color: #B5B5B5 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none;
    svg path {
      fill: #B5B5B5 !important;
    }
  }
}

.mobile-sub-item:hover {
  color: #1890ff;

  svg path {
    fill: #1890ff;
  }
}

.mobile-sub-item.active {
  color: #1890ff;
  font-weight: 500;
}

.mobile-sub-item:last-child {
  border-bottom: none;
}

.mobile-buttons {
  padding: 20px;
}

.join-btn {
  background: #1890ff;
  color: white;
  margin-bottom: 12px;
  height: 44px;
  font-size: 16px;
}

.login-btn {
  color: #1890ff;
  border-color: #1890ff;
  height: 44px;
  font-size: 16px;
}

.logout-btn {
  background: #ff4d4f;
  color: white;
  height: 44px;
  font-size: 16px;
}
</style>
